import { Group, Tooltip as MTooltip, Text } from "@mantine/core";
import { IconInfoCircle, IconInfoCircleFilled } from "@tabler/icons-react";
import type React from "react";
import { useMemo } from "react";

interface Props {
  label: string;
  text: string[] | React.ReactNode;
}

const SSTooltip: React.FC<Props> = ({ label, text }) => {
  const isValidText = Array.isArray(text) && text.filter((t) => t).length > 0;
  const validText = useMemo(() => {
    if (!Array.isArray(text)) return text;

    return text.map((item) => (
      <span key={text as unknown as string}>
        {item}
        <br />
      </span>
    ));
  }, [text]);

  return (
    <>
      {label}{" "}
      {isValidText && (
        <MTooltip
          multiline
          withArrow
          className="max-w-[50%] rounded-lg bg-primary-default/50 shadow-md backdrop-blur-md lg:max-w-[30%]"
          label={
            <Group className="px-2 py-5" wrap="nowrap" gap={25}>
              <IconInfoCircleFilled className="w-[50px] text-primary-dark-text" />
              <Text className="font-inter text-primary-dark-text text-sm">
                {validText}
              </Text>
            </Group>
          }
          position="right"
          transitionProps={{ duration: 200 }}
        >
          <IconInfoCircle className="inline-block cursor-pointer" size={15} />
        </MTooltip>
      )}
    </>
  );
};

export default SSTooltip;
